/**
 * Telling "this page is from before the last release" apart from a real error,
 * and recovering from it. Used by `RouteError` and by `main.tsx`.
 */

const RELOADED_AT = "smartspaza.reloaded-for-new-version";

/** How each browser words "a file this page needs is gone". */
const STALE_FILE = [
  "Importing a module script failed", // Safari
  "Failed to fetch dynamically imported module", // Chrome, Edge
  "error loading dynamically imported module", // Firefox
  "Unable to preload CSS",
  "Loading chunk",
];

export function isStaleFileError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === "string" ? error : "";
  return STALE_FILE.some((text) => message.includes(text));
}

/**
 * Reload to pick up the new version — once.
 *
 * Guarded by a timestamp, because if the reload does not cure it (an old copy
 * served from a cache somewhere), a page that reloaded on every failure would
 * reload forever. Returns whether it reloaded.
 */
export function reloadForNewVersion(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOADED_AT) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(RELOADED_AT, String(Date.now()));
  } catch {
    // Storage blocked: reload anyway. One extra reload beats a dead screen.
  }
  window.location.reload();
  return true;
}
